export const styles = {
  container: {
    cursor: 'pointer',
    overflow: 'visible',
    position: 'relative',
    display: 'flex',
  },
  modal: {
    opacity: 1,
    position: 'absolute',
    width: '340px',
    height: 'auto',
    padding: '1rem',
    zIndex: '999',
    top: -140,
    left: -340,
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 16px 0px #2737541a',
    display: 'flex',
    alignItems: 'flex-start',
    color: '#4f5b94',
  },
  logo: {
    marginRight: '10px',
  },
  text: {
    backgroundColor: '#fff',
  },
}
